export const useTestScreen = (slug) => useFetchSafely(() => `tests/${slug}`);

export const useRelatedTests = (slug) => useFetchSafely(() => `tests/related-tests/${slug}`);

export const useTestFaqs = (slug) => useFetchSafely(() => `faqs_service/${slug}`);

export const useTestDetail = () => useFetchSafelyCached("tests");
